import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ProductAlertsManagePage = lazy(() =>
  import("@scenes/ProductAlerts/components/ProductAlertsManagePage/ProductAlertsManagePage").then((module) => ({
    default: module.ProductAlertsManagePage,
  }))
);

export const productAlertsNRO: NavigationRoutingObject = {
  Component: ProductAlertsManagePage,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "messaging",
  heading: (t: I18nT<"dashboard-navigation">) => t("product-alerts-nro-heading", "Product Alerts"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t("product-alerts-nro-description", "Manage threshold-based alerts across your Canvases"),
  icon: "nav-system-canvas",
  tag: "early-access",
  pageNameForTracking: () => "Product Alerts",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return featureOn("product_alerts") && hasPermission("appGroup", { permission: "viewCanvases" });
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("product-alerts-nro-additional-keyword-alerts", "alerts"),
        t("product-alerts-nro-additional-keyword-monitoring", "monitoring"),
        t("product-alerts-nro-additional-keyword-thresholds", "thresholds"),
      ],
      description: t("product-alerts-nro-additional-description-canvas-alerts", "Canvas alerts"),
    },
  ],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/product_alerts/:appGroupId",
};
